import React, { useState, useEffect } from 'react';
import {
  Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Typography, Paper, Alert
} from '@mui/material';
import { Download } from '@mui/icons-material';
import { getApartments, downloadExcelReport, USE_MOCK_DATA } from '../services/api';
import { mockApartments } from '../services/mockData';

export default function Reports() {
  const [apartments, setApartments] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState('');
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [downloading, setDownloading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (USE_MOCK_DATA) {
      const userApartments = [mockApartments[0]];
      setApartments(userApartments);
      setSelectedApartment(userApartments[0].id);
      return;
    }
    getApartments().then(res => {
      setApartments(res.data);
      if (res.data.length > 0) setSelectedApartment(res.data[0].id);
    }).catch(() => {});
  }, []);

  const handleDownloadExcel = async () => {
    setDownloading(true);
    setMessage('');
    if (USE_MOCK_DATA) {
      setTimeout(() => {
        setMessage('Mock mode: Excel report would be downloaded here when backend is running.');
        setDownloading(false);
      }, 500);
      return;
    }
    try {
      const response = await downloadExcelReport(selectedApartment, month, year);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const apt = apartments.find(a => a.id === selectedApartment);
      link.setAttribute('download', `Report_${apt?.name}_${month}_${year}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setMessage('Failed to download report. Make sure the backend is running.');
    }
    setDownloading(false);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>Monthly Reports</Typography>
      <Paper sx={{ p: 3 }}>
        {message && <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>}
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Apartment</InputLabel>
              <Select value={selectedApartment} label="Apartment" onChange={(e) => setSelectedApartment(e.target.value)}>
                {apartments.map(a => <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Month</InputLabel>
              <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
                {Array.from({ length: 12 }, (_, i) => <MenuItem key={i + 1} value={i + 1}>{new Date(2000, i).toLocaleString('default', { month: 'long' })}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Year</InputLabel>
              <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
                {Array.from({ length: 5 }, (_, i) => <MenuItem key={i} value={new Date().getFullYear() - i}>{new Date().getFullYear() - i}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button variant="contained" startIcon={<Download />} fullWidth onClick={handleDownloadExcel} disabled={downloading || !selectedApartment}>
              {downloading ? 'Downloading...' : 'Excel'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
